import React from 'react';
import styled from 'styled-components';
import {useFormiflyContext} from "formifly";
import {dark_green, highlight_green} from "../colors";
import {CloseButtonSvg} from "./CloseButton";
import {OpenButtonSvg} from "./OpenButton";

const OptionsMenu = styled.menu`
    background-color: ${props => props.theme.inputBackgroundColor};
    margin: 0;
    z-index: 1000;
    padding: 0.25rem 0 0.25rem 0;
    list-style: none;
    width: 100%;
    
    li {
        padding: 0 0.25rem 0 0.25rem;
        
        label {
            width: 100%;
            display: block;
            cursor: pointer;
        }
    }
`;

const SelectedDisplay = styled.span`
    color: ${props => props.theme.inputTextColor};
    position: absolute;
    padding: 4px;
    top: -5px;
    right: -30px;
    display: block;
    min-width: 21px;
    text-align: center;
    background-color: ${highlight_green};
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: bold;
    line-height: 0.8rem;
`;

const SelectContainer = styled.div`
    cursor: pointer;
    border-bottom: 1px solid ${props => props.theme.inputBorderColor};
    padding: 0.5rem 0.25rem;
    min-width: 15rem;
    width: 100%;
`;

const SelectLabelContainer = styled.div`
    position: relative;
`;

const SelectLabel = styled.label`
    position: relative;
    cursor: pointer;
    user-select: none;
`;

const CheckLabel = styled.label`
    cursor: pointer;
    padding: 2px 0;
    
    & input {
        cursor: pointer;
        margin-right: 7px;
    }
`;

const OpenCloseButton = styled.button`
    border: none;
    background-color: transparent;
    position: absolute;
    right: 0;
    
    & path {
        fill: ${dark_green};
    }
`;

export const Option = (props) => {
    const {onChange, label, checked, className} = props;
    return <li className={className}>
        <CheckLabel><input onChange={onChange} type="checkbox" checked={checked}/>{label}</CheckLabel>
    </li>;
};

const MultiSelectField = (props) => {
    const {
        label,
        options,
        menuClassName,
        optionClassName,
    } = props;
    const {getFieldProps} = useFormiflyContext();
    const {
        name,
        value,
        onChange,
    } = getFieldProps(props.name, props.help, props.type, props.value, props.id, props.additionalDescribedBy);

    const [menuVisible, setMenuVisible] = React.useState(false);

    const handleOptionChange = (optionValue) => {
        if (value.includes(optionValue)) {
            onChange(name, value.filter(val => val !== optionValue));
        } else {
            onChange(name, [...value, optionValue]);
        }

        // Extremely hacky approach because I found no way to do that otherwise
        setTimeout(() => {
            const forms = document.getElementsByClassName('workplace-formifly-form');
            if (forms.length) {
                forms[0].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
        }, 25);
    };

    return <SelectContainer className={'formifly-multi-select-container'}>
        <SelectLabelContainer onClick={() => setMenuVisible(!menuVisible)}>
            <SelectLabel htmlFor={name}>
                {label}
                {value.length > 0 && <SelectedDisplay>
                    {String(value.length)}
                </SelectedDisplay>}
            </SelectLabel>
            <OpenCloseButton>
                {menuVisible && <CloseButtonSvg />}
                {!menuVisible && <OpenButtonSvg />}
            </OpenCloseButton>
        </SelectLabelContainer>
        {menuVisible && <OptionsMenu className={'formifly-multi-select-menu ' + (menuClassName ?? '')} aria-required={props['aria-required']}>
            {options.map((option, key) => <Option key={'multiSelectOption' + key}
                                                  onChange={() => handleOptionChange(option.value)}
                                                  className={'formifly-multi-select-option ' + (optionClassName ?? '')}
                                                  checked={value.includes(option.value)}
                                                  label={option.label}/>)}
        </OptionsMenu>}
    </SelectContainer>;
};

export default React.memo(MultiSelectField);
